export const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_UPDATE_USER_SUCCESS = 'FETCH_UPDATE_USER_SUCCESS'
export const FETCH_USER_PERSONAL_DATA_ERROR = 'FETCH_USER_PERSONAL_DATA_ERROR'
export const FETCH_UPDATE_USER_ERROR = 'FETCH_UPDATE_USER_ERROR'
export const FETCH_USER_PERSONAL_DATA_REQUEST = 'FETCH_USER_PERSONAL_DATA_REQUEST'
export const FETCH_USER_PERSONAL_DATA_SUCCESS = 'FETCH_USER_PERSONAL_DATA_SUCCESS'
export const FETCH_USER_VIGENTE_REQUEST = 'FETCH_USER_VIGENTE_REQUEST'
export const FETCH_USER_VIGENTE_SUCCESS = 'FETCH_USER_VIGENTE_SUCCESS'
export const FETCH_USER_VIGENTE_ERROR = 'FETCH_USER_VIGENTE_ERROR'

export const USER_HAS_CVL = 'USER_HAS_CVL'
export const USER_HAS_SOLICITUD_CREDITO = 'USER_HAS_SOLICITUD_CREDITO'
export const TESTUSER = 'TESTUSER'
